module.exports = __webpack_public_path__ + "static/media/Live.c43fe68d.svg";